/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab.ts";
import { courseRegistrationManagementCourseAccessViewModelSchema } from "../courseRegistrationManagementCourseAccessViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab200Schema =
  z.lazy(
    () => courseRegistrationManagementCourseAccessViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse>;
